<template>
<Pagebody :loading='loading' :subnav="$store.getters.subnavNames">
    <a class="back_btn" @click="$router.go('-1')">返回</a>
    <div id="room">
        <div class="row tooltips" style="width: 50%;margin: 0 auto;line-height: 25px;">
            <div style="float: left;">
                <div class="sit bg-sit no-hover bg-num" style="margin: 4px;"></div>可选座位
            </div>
            <div style="float: left;margin: 0 76px;">
                <div class="sit bg-sited  bg-num" style="margin: 4px;"></div>已售座位
            </div>
            <div style="float: left;">
                <div class="sit bg-temp  bg-num" style="margin: 4px;"></div>已选座位
            </div>
        </div>
        <div class="blank">
        </div>
        <div class="row">
            <div class="blackboard"></div>
            <!-- <div class="platform">讲台</div> -->
        </div>

        <div class="blank">
        </div>
        <div v-for="(item, i) in list[key]" :key="i" class="row">
            <div class="sit bg-nosit bg-num" style="margin-right:50px">{{i+1}}</div>
            <div v-for="(item1,j) in item" :key="j" @click="selectSeat(item1,i,j)"
                :class="['sit',{'bg-temp':item1==3},{'bg-sited':item1==2},{'bg-sit':item1==1},{'bg-nosit':item1==0},{'bg-dontsit':item1==4}]">
            </div>
        </div>
        <div class="row clearfix choose">
            <div style="font-size: 14px;line-height: 28px;" v-show="seats.length > 0">已选座位</div>
            <div v-for="(sit, i) in seats" :key="i">
                <div>
                    <div class="select-sit">{{sit}}</div>
                </div>
            </div>
        </div>
        <normal-button class="buy" theme="blue" :class="{disabled: msg.length <= 0}" @click='buynow'>确定座位</normal-button>
        <div class="booking_area">
            <div class="head-title">
                <span>教室实景</span>
            </div>
            <div class="classPic">
                <div class="pic" v-for="(src,index) in pics" :key='index' @click="showPic(index)">
                    <img :src="src">
                </div>
            </div>
            <div class="fullscreen_pic" v-show="fullImgShow" @click="fullImgShow=false">
                <div class="photo"  @click.stop="()=>{}">
                    <div class="page">
                        <p class="num">{{pics_index+1}}/{{pics.length}}</p>
                    </div>
                    <a class="btn_prev" v-show='pics_index > 0' @click="prevPic"></a>
                    <div class="o_h_content">
                        <div class="close_btn" @click='fullImgShow = false'></div>
                        <div class="photo_wrap" :style="{
                            transform: `translateX(${translatePic}%)`
                        }">
                            <img v-for="(src, index) in pics" :key="index" :src="src" />
                        </div>
                    </div>
                    <a class="btn_next" v-show='pics_index < pics.length - 1'  @click="nextPic"></a>
                </div>
            </div>
            
        </div>
    </div>
</Pagebody>
</template>
<script>
import cookie from 'js-cookie'
import wh from '@/assets/js/wh.js'
import NormalButton from '../../base/NormalButton.vue'
    export default {
    components: { NormalButton },
        data() {
            return {
                // 场次信息
                filmSession: {
                    //放映点名称
                    svname: "花语影院",
                    //放映点地址
                    svaddress: "5号放映厅",
                    //开始时间
                    fstartTime: new Date(),
                    filmName: "社会",
                    filmType: "黑道",
                    filmImg: "images/2.jpg",
                    filmPrice: 33.50
                },
                // 座位状态数组
                list: {
                    default: [
                        [0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0,
                            0],
                        [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1,
                            0],
                        [1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1,
                            1],
                        [1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 2, 2, 1, 0, 1, 2, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1,
                            0],
                        [1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 0,
                            0],
                        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0,
                            0]
                    ],
                    bj: [
                        [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1],
                        [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1],
                        [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1],
                        [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1],
                        [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1],
                        [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1],
                        [0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 1, 1]
                    ],
                    sh_old: [
                        [0, 0, 0, 0, 0, 1, 1, 1, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 0, 0,
                            0],
                        [0, 0, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1,
                            0],
                        [1, 1, 1, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 1, 1,
                            1],
                        [1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0, 1, 1, 1, 1, 1,
                            0],
                        [1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 1, 1, 1, 1, 0,
                            0],
                        [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0,
                            0]
                    ],
                    SH: [
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0]
                    ],
                    BJ: [
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0],
                        [0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0, 1, 1, 0]
                    ]
                },
                pics: [
                    // require('@/assets/image/classroom_1.jpg'),
                    // require('@/assets/image/classroom_2.jpg'),
                    require('@/assets/image/classroom_3.jpg'),
                    require('@/assets/image/classroom_4.jpg'),
                ],
                pics_index: 0,
                key: '',
                loading: true,
                fullImg: '',
                fullImgShow: false,
                msg: [], //已选坐标
                seats: [] //已选座位文字
            }
        },
        inject: ['appOverFlow','popOverShow','paymentShow','orderShow','initOrder','setSeatInstance'],
        methods: {
            // 选座时触发
            selectSeat(data, x, y) {
                if (data == 1 && this.msg.length < this.$route.query.count) {
                    this.addSeat(x,y)
                } else if (data == 3) {
                    // 用于记录要删除的座位下标
                    this.delSeat(x,y)
                } else {
                    if (this.msg.length == this.$route.query.count) {
                        this.$market.alert({
                            content: "最多只能选择"+this.$route.query.count+"个座位！"
                        });
                        // alert("最多只能订4张票！")
                    }
                }
                
            },
            // 设置已选的座位
            sub() {
                //疫情原因，先写死
                // this.list.SH = [
                //     [0, 2, 4, 0, 2, 4, 0, 2, 4, 0, 2, 4, 0],
                //     [0, 2, 4, 0, 2, 4, 0, 2, 4, 0, 2, 4, 0],
                //     [0, 2, 4, 0, 2, 4, 0, 2, 4, 0, 2, 4, 0],
                //     [0, 2, 4, 0, 2, 4, 0, 2, 4, 0, 2, 4, 0],
                //     [0, 1, 4, 0, 2, 4, 0, 1, 4, 0, 1, 4, 0]
                // ]
                // this.key = 'SH'
                // this.loading = false
                this.$axios({
                    url: "/api/Order/GetMyypxsize",
                    method: "get"
                }).then(({data})=>{
                    this.key = data.seatmap
                    this.type = data.type
                    let guid = cookie.get('seat_guid')
                    if (!guid) {
                        guid = wh.randomId()
                        cookie.set('seat_guid',guid)
                    }
                    this.$axios({
                        url: "/api/Order/GetSeat",
                        method: "post",
                        data: {
                            type: this.type,
                            guid
                        }
                    }).then(({data})=>{
                        if (data.status) {
                            this.loading = false
                            if (data.data) {
                                data.data.purchaseSeat.forEach(el => {
                                    this.setSeatState(el.row, el.col, 2)
                                });
                                data.data.selectSeat.forEach(el => {
                                    this.addSeat(el.row, el.col)
                                });
                                
                            }
                        }
                    })

                })
                
            },
            setSeatState (x,y,n) {
                this.list[this.key][x][y] = n;
                let arr = []
                this.list[this.key] && this.list[this.key].forEach((v,i)=>{
                    v.forEach((el, j) => {
                        if (el == 3) {
                            arr.push([i,j])
                        }
                    })
                })
                this.msg = arr
            },
            addSeat (x,y) {
                this.setSeatState(x,y,3)
            },
            delSeat (x,y) {
                this.setSeatState(x,y,1);
            },
            clearSeat () {
                this.list[this.key].forEach((v,i)=>{
                    v.forEach((el,j)=>{
                        if (el == 3) {
                            this.setSeatState(i,j,1)
                        }
                    })
                })
            },
            saleSeat () {
                this.list[this.key].forEach((v,i)=>{
                    v.forEach((el,j)=>{
                        if (el == 3) {
                            this.setSeatState(i,j,2)
                        }
                    })
                })
            },
            buynow(finish) {
                if (this.msg.length != this.$route.query.count) {
                    finish()
                    return this.$market.alert({
                        content: "请选择"+this.$route.query.count+"个座位！"
                    });
                }
                
                let guid = cookie.get('seat_guid')
                if (!guid) {
                    guid = wh.randomId()
                    cookie.set('seat_guid',guid)
                }
                let rowCol = this.msg
                this.$axios({
                    url: "/api/Order/CreateSeat",
                    method: "post",
                    data: {
                        guid,
                        rowCol,
                        type: this.type,
                        Seat: this.seats.join(','),
                        SeatType: 1
                    }
                }).then(({data})=>{
                    if (data.status) {
                        finish()
                        // this.$router.go('-1')
                        this.$router.push({
                            path: '/detail/'+this.$route.query.id,
                            query: {
                                livetype: 1
                            }
                        })
                    } else {
                        this.$market.alert({content: data.message})
                    }
                })
                return
            },
            showPic(index) {
                this.pics_index = index
                this.fullImgShow = true
            },
            prevPic () {
                if (this.pics_index > 0) {
                    this.pics_index--
                }
            },
            nextPic () {
                if (this.pics_index < this.pics.length - 1) {
                    this.pics_index++
                }
            }
        },
        computed: {
            translatePic () {
                return this.pics_index * -100
            }
        },
        watch: {
            msg () {
                let data = this.list[this.key]
                let arr = []
                data.forEach((v,i)=>{
                    let colIndex = 0
                    v.forEach((el,j)=>{
                        if (el != 0) {
                            colIndex++
                            if (el == 3) {
                                arr.push(`${i+1}排${colIndex}座`)
                            }
                        }
                    })
                })
                this.seats = arr
            }
        },
        mounted: function () {
            this.sub();
        },
        filters: {
            // 日期过滤器
            time(data) {
                var date = new Date(data);
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hours = date.getHours() > 9 ? date.getHours() : ("0" + date.getHours());
                var minutes = date.getMinutes() > 9 ? date.getMinutes() : ("0" + date.getMinutes());
                return month + "月" + day + "日  " + hours + ":" + minutes;
            },
            // 价格过滤器,数字保留两位小数
            price(data) {
                var price = parseFloat(data);
                return price.toFixed(2);
            }
        }
    }
</script>
<style scoped src="./style.css"></style>